import { render, staticRenderFns } from "./district.vue?vue&type=template&id=37b93262&scoped=true&"
import script from "./district.vue?vue&type=script&lang=js&"
export * from "./district.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b93262",
  null
  
)

export default component.exports